import React, { useLayoutEffect, useMemo, useRef } from "react";
import styled from "styled-components";
import { WrapperContainer, imgbaseUrl } from "./SliderItem";
import { ParagraphWithLightBorder, TitleH4 } from "./About";
import { TitleWithBigMargin } from "./Services";
import { DefaultMediaIconContainer, MediaIcon } from "./Header";
import {
  faFacebookF,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { smDown, mdDown } from "../utils/responsive";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Acheampong, Acolatse, Eunice, Kelvin, Raymond, William } from "../utils/constants";

const Container = styled(WrapperContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 48px;
  padding-bottom: 48px;
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CardWrapper = styled.div`
  width: 100%;
  padding: 24px 0;
`;

const Card = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;

  ${mdDown({
    flexDirection: "column",
    alignItems: "center",
  })}
`;

const CardImg = styled.img`
  width: 30%;
  height: auto;
  object-fit: cover;
  border-radius: ${({ theme }) => theme.borderRadius};
  max-height: 300px;

  ${mdDown({
    width: "100%",
    maxWidth: "280px",
  })}
`;

const ProfileDetails = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.palette.primary.light};
  border-radius: ${({ theme }) => theme.borderRadius};
  transition: background-color 300ms linear;

  ${mdDown({
    width: "100%",
    alignItems: "center",
    textAlign: "center",
  })}
`;

const Name = styled.h4`
  margin: 0 0 8px 0;
  font-size: 1.25rem;
`;

const Role = styled.p`
  margin: 0 0 16px 0;
  font-size: 1rem;
  color: ${({ theme }) => theme.palette.primary.darker};
`;

const Profile = styled.p`
margin: 0 0 16px 0;
font-size: 1.2rem;
/* color: ${({ theme }) => theme.palette.primary.darker}; */
`;

const MediaContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 16px;

  ${mdDown({
    justifyContent: "center",
  })}
`;

const StyledMediaIconContainer = styled(DefaultMediaIconContainer)`
  background-color: ${({ theme }) => theme.palette.primary.light};
  transition: background-color 300ms linear;
  width: 38px;
  height: 38px;
  margin: 0 4px;
  cursor: pointer;

  & svg {
    transition: color 300ms linear;
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.primary.main};
    & svg {
      color: ${({ theme }) => theme.palette.primary.light};
    }
  }
`;

const Team = () => {
  interface CardItemType {
    name: string;
    role: string;
    profile: string;
    img: number;
  }

  const cardItem: CardItemType[] = useMemo(
    () => [
      {
        name: "Mr. Kwame Atta Acheampong",
        role: "Board Chairman",
        profile: Acheampong,
        img: 5,
      },
      {
        name: "Mr. William Kuffour Bonsu",
        role: "Managing Director",
        profile: William,
        img: 2,
      },
      {
        name: "Mr. Benjamin Kweku Acolatse",
        role: "Director",
        profile: Acolatse,
        img: 1,
      },
    
      {
        name: "Mr. Kelvin Williams Aye-Kumi",
        role: "Head, Credit Risk",
        profile: Kelvin,
        img: 3,
      },
   
      {
        name: "Eunice Adane Yeboah",
        role: "Head, Finance",
        profile: Eunice,
        img: 6,
      },
    ],
    []
  );

  const containerEl = useRef<HTMLDivElement>(null);
  const topEl = useRef<HTMLDivElement>(null);
  const cardWrapperEls = useRef<HTMLDivElement[]>([]);
  const addToCardwrapperRefs = (el: HTMLDivElement) => {
    if (el && !cardWrapperEls.current.includes(el))
      cardWrapperEls.current.push(el);
  };

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: containerEl.current,
        start: "top center",
      },
    });
    tl.from(topEl.current, {
      opacity: 0,
      y: "100%",
    }).from(cardWrapperEls.current, {
      opacity: 0,
      y: "100%",
      stagger: 0.2,
    });

    return () => {
      tl.scrollTrigger?.kill();
    };
  }, []);

  const handleLoad = () => {
    ScrollTrigger.refresh();
  };

  return (
    <Container ref={containerEl}>
      <Top ref={topEl}>
        <ParagraphWithLightBorder>Our Team</ParagraphWithLightBorder>
        <TitleWithBigMargin>Exclusive Team</TitleWithBigMargin>
      </Top>
      <CardContainer>
        {cardItem.map(({ name, role,profile, img }, idx) => (
          <CardWrapper ref={addToCardwrapperRefs} key={idx}>
            <Card>
              <CardImg
                onLoad={handleLoad}
                src={`${imgbaseUrl}team-${img}.jpg`}
                alt={name}
              />
              <ProfileDetails>
                <Name>{name}</Name>
                <Role>{role}</Role>
                <Profile>{profile}</Profile>
                {/* <MediaContainer>
                  <StyledMediaIconContainer to="">
                    <MediaIcon icon={faFacebookF} />
                  </StyledMediaIconContainer>
                  <StyledMediaIconContainer to="">
                    <MediaIcon icon={faTwitter} />
                  </StyledMediaIconContainer>
                  <StyledMediaIconContainer to="">
                    <MediaIcon icon={faInstagram} />
                  </StyledMediaIconContainer>
                </MediaContainer> */}
              </ProfileDetails>
            </Card>
          </CardWrapper>
        ))}
      </CardContainer>
    </Container>
  );
};

export default Team;
